import { watchEffect } from 'vue'
import { createI18n } from 'vue-i18n'
// DeepUiLib locales
import { locales, setI18nLocale } from '@deepcloud/deep-ui-lib'
import vuetify from '@/plugins/vuetify'
import getEnv from '@/util/env.ts'
import de from './locales/de.json'
import en from './locales/en.json'
import fr from './locales/fr.json'
import it from './locales/it.json'

type AvailableLocales = 'de' | 'en' | 'fr' | 'it'

export const i18n = createI18n({
  legacy: false,
  locale: getEnv('VITE_I18N_LOCALE') || 'en',
  fallbackLocale: getEnv('VITE_I18N_FALLBACK_LOCALE') || 'en',
  flatJson: true,
  silentTranslationWarn: true,
  warnHtmlMessage: false,
  globalInjection: true,
  messages: {
    de,
    en,
    fr,
    it,
  },
})

i18n.global.mergeLocaleMessage('de', locales.de)
i18n.global.mergeLocaleMessage('fr', locales.fr)
i18n.global.mergeLocaleMessage('it', locales.it)
i18n.global.mergeLocaleMessage('en', locales.en)

watchEffect(() => {
  const locale = i18n.global.locale.value
  if (locale) {
    document.documentElement.lang = locale
    vuetify.locale.current.value = locale
    setI18nLocale(locale as AvailableLocales)
  }
})
